"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7226],{

/***/ 67179:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.OTHER_CURATION_PORTAL_FACET_NAMES = exports.CURATION_PORTAL_FACET_NAMES = exports.PRINT_CURATION_PORTAL_FACET_NAMES = exports.COMMON_CURATION_PORTAL_FACET_NAMES = void 0;
exports.COMMON_CURATION_PORTAL_FACET_NAMES = {
    SORT: "sort",
    CURATED_STATUS: "curated_status_value",
    AVAILABILITY_STATUS: "original_availability_status",
    CATEGORY: "artwork_category",
    STYLES: "styles",
    SUBJECT: "subject",
    MEDIUMS: "mediums",
    SIZE: "size_bin",
    PRICE: "geo_prices",
    ARTIST_COUNTRY: "country",
    US_STATE: "us_state",
    CITY: "city",
    ORIENTATION: "orientation",
    MATERIALS: "materials",
    FEATURED_IN: "artist_recognition",
    COLOR: "color",
    READY_TO_HANG: "is_ready_to_hang",
    FRAMED: "is_framed",
    PANELS: "panels",
    OUTDOOR_SAFE: "is_outdoor_safe",
    PACKAGING: "packaging",
    ARTIST_GENDER: "artist_gender",
    ARTIST_ETHNICITY: "artist_ethnicity"
};
exports.PRINT_CURATION_PORTAL_FACET_NAMES = {
    PRINT_MATERIAL: "print_materials",
    PRINT_SIZE: "print_size_bins",
    PRINT_ORIENTATION: "print_orientations",
    PRINT_PRICE: "print_all_prices_values"
};
exports.CURATION_PORTAL_FACET_NAMES = Object.assign(Object.assign({}, exports.COMMON_CURATION_PORTAL_FACET_NAMES), exports.PRINT_CURATION_PORTAL_FACET_NAMES);
exports.OTHER_CURATION_PORTAL_FACET_NAMES = {
    CURATED_STATUS: "curated_status"
};


/***/ }),

/***/ 79941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (void 0) && (void 0).__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.constructorGetDataByIds = constructorGetDataByIds;
exports.constructorGetData = constructorGetData;
exports.constructorGetFacets = constructorGetFacets;
exports.constructorGetAutocomplete = constructorGetAutocomplete;
exports.constructorGetRecommendations = constructorGetRecommendations;
const slugify_1 = __webpack_require__(6663);
const constants_1 = __webpack_require__(66265);
const createConstructorInstances_1 = __webpack_require__(67370);
function constructorGetDataByIds(_a) {
    return __awaiter(this, arguments, void 0, function*({ ids , page =1 , resultsPerPage =100 , filters ={} , isServerSide , userId ,  }) {
        const constructorio = isServerSide && "object" === "undefined" ? 0 : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({
            userId
        });
        return yield constructorio.browse.getBrowseResultsForItemIds(ids, {
            page,
            resultsPerPage,
            filters
        });
    });
}
function constructorGetData(_a) {
    return __awaiter(this, arguments, void 0, function*({ query ="" , page =1 , resultsPerPage =100 , filters ={} , sortBy , sortOrder , selectedCategory ="all" , isServerSide , userId , filterByIds , preFilterExpression ,  }) {
        var _b, _c, _d, _e;
        try {
            const constructorio = isServerSide && "object" === "undefined" ? 0 : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({
                userId
            });
            const slugifiedSelectedCategory = (0, slugify_1.slugify)(selectedCategory);
            const groupIdValue = constants_1.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER[slugifiedSelectedCategory] || slugifiedSelectedCategory;
            const response = yield (()=>__awaiter(this, void 0, void 0, function*() {
                    if (filterByIds === null || filterByIds === void 0 ? void 0 : filterByIds.length) {
                        return constructorGetDataByIds({
                            ids: filterByIds,
                            page,
                            resultsPerPage,
                            filters,
                            isServerSide,
                            userId
                        });
                    }
                    if (query === "") {
                        return constructorio.browse.getBrowseResults("group_id", groupIdValue, Object.assign({
                            page,
                            resultsPerPage,
                            filters,
                            sortBy,
                            sortOrder
                        }, preFilterExpression ? {
                            preFilterExpression
                        } : {}));
                    }
                    return constructorio.search.getSearchResults(query, Object.assign({
                        page,
                        resultsPerPage,
                        filters,
                        sortBy,
                        sortOrder
                    }, preFilterExpression ? {
                        preFilterExpression
                    } : {}));
                }))();
            // console.log('Constructor Response data', response)
            if ("redirect" in response.response) {
                return {
                    type: "redirect",
                    redirect: response.response.redirect
                };
            }
            const requestFromConstructor = response.request;
            const responseFromConstructor = response.response;
            const dataFromConstructor = responseFromConstructor.results;
            const facetsFromConstructor = responseFromConstructor.facets;
            const totalNumResultsFromConstructor = (((_c = (_b = responseFromConstructor === null || responseFromConstructor === void 0 ? void 0 : responseFromConstructor.result_sources) === null || _b === void 0 ? void 0 : _b.token_match) === null || _c === void 0 ? void 0 : _c.count) || 0) + (((_e = (_d = responseFromConstructor === null || responseFromConstructor === void 0 ? void 0 : responseFromConstructor.result_sources) === null || _d === void 0 ? void 0 : _d.embeddings_match) === null || _e === void 0 ? void 0 : _e.count) || 0);
            return {
                type: "products",
                request: requestFromConstructor,
                response: responseFromConstructor,
                results: dataFromConstructor,
                facets: facetsFromConstructor,
                totalResults: totalNumResultsFromConstructor
            };
        } catch (error) {
            console.error("Constructor.io data error:", error);
            return {
                type: "error",
                error: {
                    message: "Error getting data from Constructor"
                },
                totalResults: 0
            };
        }
    });
}
function constructorGetFacets(_a) {
    return __awaiter(this, arguments, void 0, function*({ query ="" , page =1 , resultsPerPage =100 , filters ={} , sortBy , sortOrder ="descending" , selectedCategory ="all" , isServerSide , userId ,  }) {
        var _b;
        try {
            const constructorio = isServerSide && "object" === "undefined" ? 0 : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({
                userId
            });
            const slugifiedSelectedCategory = (0, slugify_1.slugify)(selectedCategory);
            const groupIdValue = constants_1.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER[slugifiedSelectedCategory] || slugifiedSelectedCategory;
            const response = query === "" ? yield constructorio.browse.getBrowseResults("group_id", groupIdValue, {
                page,
                resultsPerPage,
                filters,
                sortBy,
                sortOrder
            }) : yield constructorio.search.getSearchResults(query, {
                page,
                resultsPerPage,
                filters,
                sortBy,
                sortOrder
            });
            // console.log('Results Facets:', response)
            // const facetsFromConstructor: ConstructorFacetsResponse = getMockFacets()
            const facetsFromConstructor = "facets" in response.response ? (_b = response.response) === null || _b === void 0 ? void 0 : _b.facets : [];
            return facetsFromConstructor;
        } catch (error) {
            console.error("Constructor.io facets error:", error);
            return [];
        }
    });
}
function constructorGetAutocomplete(_a) {
    return __awaiter(this, arguments, void 0, function*({ query ="" , filters ={} , numResults , isServerSide , userId ,  }) {
        try {
            const constructorio = isServerSide && "object" === "undefined" ? 0 : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({
                userId
            });
            const response = yield constructorio.autocomplete.getAutocompleteResults(query, {
                filters,
                numResults
            });
            // console.log(`Autocomplete for ${query} :`, response)
            return {
                request: response.request,
                sections: response.sections,
                totalResultsPerSection: response.total_num_results_per_section
            };
        } catch (error) {
            console.error("Constructor.io data error:", error);
            return {
                request: null,
                sections: {},
                totalResultsPerSection: {}
            };
        }
    });
}
function constructorGetRecommendations(_a) {
    return __awaiter(this, arguments, void 0, function*({ podId ="" , filters ={} , numResults , section ="Products" , isServerSide , userId , itemIds ,  }) {
        var _b;
        try {
            const constructorio = isServerSide && "object" === "undefined" ? 0 : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({
                userId
            });
            const response = yield constructorio.recommendations.getRecommendations(podId, {
                numResults,
                filters,
                section,
                itemIds
            });
            // console.log(`Recommendations for ${podId}:`, response)
            return {
                request: response.request,
                response: response.response,
                totalResults: ((_b = response.response) === null || _b === void 0 ? void 0 : _b.total_num_results) || 0,
                resultId: (response === null || response === void 0 ? void 0 : response.result_id) || ""
            };
        } catch (error) {
            console.error("Constructor.io data error:", error);
            return {
                request: null,
                response: null,
                totalResults: 0,
                resultId: ""
            };
        }
    });
}


/***/ }),

/***/ 67370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getConstructorInstanceServerSide = exports.getConstructorInstanceClientSide = exports.getConstructorIndex = void 0;
const constructorio_client_javascript_1 = __importDefault(__webpack_require__(96358));
const getConstructorIndex = ()=>{
    const { CONSTRUCTOR_PUBLIC_INDEX_KEY  } = ({"APP_ENV":"production","STRIPE_PUBLIC_KEY":"pk_live_xPgufS8u2WdK5IKXi7akeg97","CONSTRUCTOR_PUBLIC_INDEX_KEY":"key_cn3mctZ73MD3U2jM","GOOGLE_PLACES_PUBLIC_KEY":"AIzaSyAFnkMO2LZLdPg_ki2CHaTC0ZDiPM0fr-s","GOOGLE_AUTH_PUBLIC_CLIENT_ID":"1003564750483-04idt3bfjscpuarnlmi9tktrb7utlbr8.apps.googleusercontent.com","RECAPTCHA_PUBLIC_WEBSITE_KEY_ID":"6Leuf-gcAAAAAIaS1vG3iIYXPngfZS88peQBiYyJ","SITE_URL":"https://www.saatchiart.com","SENTRY_DSN":"https://f26eb13891c84943a2c1c8d99dad495a@sentry.io/1399768","SENTRY_FORCE_ENABLED":undefined,"SENTRY_RELEASE":"19.186.2"});
    return CONSTRUCTOR_PUBLIC_INDEX_KEY || "";
};
exports.getConstructorIndex = getConstructorIndex;
const constructorClientInstances = new Map();
const constructorNodeInstances = new Map();
const getConstructorInstanceClientSide = ({ userId  })=>{
    var _a;
    const key = userId;
    if (!constructorClientInstances.has(key)) {
        const segments =  true && Array.isArray((_a = window === null || window === void 0 ? void 0 : window.cnstrc) === null || _a === void 0 ? void 0 : _a.userSegments) ? window.cnstrc.userSegments.map((segment)=>segment === null || segment === void 0 ? void 0 : segment.toString()).filter((segmentString)=>Boolean(segmentString)) : undefined;
        constructorClientInstances.set(key, new constructorio_client_javascript_1.default({
            apiKey: (0, exports.getConstructorIndex)(),
            userId: Boolean(userId) && userId !== "0" ? userId : undefined,
            segments
        }));
    }
    return constructorClientInstances.get(key);
};
exports.getConstructorInstanceClientSide = getConstructorInstanceClientSide;
const getConstructorInstanceServerSide = ({ userId  })=>{
    // the window condition is required to not have an error of trying to require this library in client side and breaking the build
    const ConstructorIONode =  false ? 0 : null;
    const key = userId;
    if (!constructorNodeInstances.has(key)) {
        constructorNodeInstances.set(key, new ConstructorIONode({
            apiKey: (0, exports.getConstructorIndex)(),
            userId: Boolean(userId) && userId !== "0" ? userId : undefined
        }));
    }
    return constructorNodeInstances.get(key);
};
exports.getConstructorInstanceServerSide = getConstructorInstanceServerSide;


/***/ }),

/***/ 44321:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getSortValues = exports.parseUrlFacets = exports.buildConstructorSlugifyDictionary = exports.sharedFacetNameList = exports.getAspectRatio = exports.rulesToSendFilters = void 0;
exports.isSafeRedirectUrl = isSafeRedirectUrl;
const url_1 = __webpack_require__(11987);
const slugify_1 = __webpack_require__(6663);
const constants_1 = __webpack_require__(30015);
const constants_2 = __webpack_require__(66265);
const facetNames_1 = __webpack_require__(88599);
const hardcodedCurationPortalFilters_1 = __webpack_require__(67179);
const convertInchesToCentimeters = (inchesValue)=>{
    return parseFloat(`${Number(inchesValue) * constants_1.INCHES_TO_CM}`).toFixed(0);
};
const rulesToSendFilters = ({ filters , destinationZone ="US" , userSizePreference , shouldAddGroupIdFilter ,  })=>{
    var _a, _b, _c, _d;
    const facetNames = Object.values(facetNames_1.FACET_NAMES);
    const otherFacets = Object.values(facetNames_1.OTHER_FACETS);
    const curationFacetNames = Object.values(hardcodedCurationPortalFilters_1.CURATION_PORTAL_FACET_NAMES);
    const otherCurationFacetNames = Object.values(hardcodedCurationPortalFilters_1.OTHER_CURATION_PORTAL_FACET_NAMES);
    const allowedFacetNames = [
        ...facetNames,
        ...otherFacets,
        ...curationFacetNames,
        ...otherCurationFacetNames,
        ...facetNames_1.UNIQUE_DESTINATION_ZONES
    ];
    // Remove basic query params from selectedFacets
    const basicQueryParam = [
        "query",
        "hitsPerPage",
        "page",
        "sort"
    ];
    const filtersToRemove = [
        "has_prints",
        "category",
        "custom__geo_prices",
        "custom__print_all_prices",
        "curation_portal_query",
        "originals_prints", 
    ];
    const mergedFiltersToRemove = [
        ...basicQueryParam,
        ...filtersToRemove
    ];
    const filtersWithoutBasicQueryParams = Object.fromEntries(Object.entries(filters).filter(([key])=>!mergedFiltersToRemove.includes(key)));
    // Format geo_prices
    if ((_a = filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams["geo_prices"]) === null || _a === void 0 ? void 0 : _a.length) {
        const ranges = filtersWithoutBasicQueryParams["geo_prices"].map((range)=>{
            const [min, max] = range.split("-").map(Number);
            const minPriceInCents = min * 100;
            const maxPriceInCents = max * 100;
            return `${minPriceInCents}-${maxPriceInCents}`;
        });
        filtersWithoutBasicQueryParams[destinationZone] = ranges;
        delete filtersWithoutBasicQueryParams["geo_prices"];
    }
    // Format print_all_prices
    if ((_b = filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams["print_all_prices_values"]) === null || _b === void 0 ? void 0 : _b.length) {
        const ranges1 = filtersWithoutBasicQueryParams["print_all_prices_values"].map((range)=>{
            const [min, max] = range.split("-").map(Number);
            const minPriceInCents = min * 100;
            const maxPriceInCents = max * 100;
            return `${minPriceInCents}-${maxPriceInCents}`;
        });
        filtersWithoutBasicQueryParams["print_all_prices"] = ranges1;
        delete filtersWithoutBasicQueryParams["print_all_prices_values"];
    }
    // Adding category filter to prints groups request (as we remove category from filters we may receive the correct group_id before final filters)
    if (shouldAddGroupIdFilter) {
        const groupIdArray = filtersWithoutBasicQueryParams["group_id"] || filters["category"];
        const slugifiedGroupIdArray = (groupIdArray || []).map((groupIdValue)=>{
            const slugifiedGroupId = (0, slugify_1.slugify)(groupIdValue);
            return constants_2.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER[slugifiedGroupId] || slugifiedGroupId;
        });
        if (slugifiedGroupIdArray.length > 0) {
            filtersWithoutBasicQueryParams["group_id"] = slugifiedGroupIdArray;
        }
    }
    // normalize value for artwork_category
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams["artwork_category"])) {
        const slugifiedArtworkCategory = (filtersWithoutBasicQueryParams["artwork_category"] || []).map((artworkCategoryValue)=>{
            const slugifiedValue = (0, slugify_1.slugify)(artworkCategoryValue);
            return constants_2.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_FILTER[slugifiedValue] || slugifiedValue;
        });
        if (slugifiedArtworkCategory.length > 0) {
            filtersWithoutBasicQueryParams["artwork_category"] = slugifiedArtworkCategory;
        }
    }
    // Formating boolean facets from 'true' to 'True' as expected by Constructor
    for(const key in filtersWithoutBasicQueryParams){
        if (Array.isArray(filtersWithoutBasicQueryParams[key])) {
            filtersWithoutBasicQueryParams[key] = filtersWithoutBasicQueryParams[key].map((filterValue)=>filterValue === "true" ? "True" : filterValue);
        }
    }
    // Format Custom dimensions to always send centimeters
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams["width"])) {
        if (userSizePreference === "in") {
            const [widthMin, widthMax] = (((_c = filtersWithoutBasicQueryParams["width"]) === null || _c === void 0 ? void 0 : _c[0]) || "").split("-");
            filtersWithoutBasicQueryParams["width"] = [
                `${convertInchesToCentimeters(widthMin)}-${convertInchesToCentimeters(widthMax)}`, 
            ];
        }
    }
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams["height"])) {
        if (userSizePreference === "in") {
            const [heightMin, heightMax] = (((_d = filtersWithoutBasicQueryParams["height"]) === null || _d === void 0 ? void 0 : _d[0]) || "").split("-");
            filtersWithoutBasicQueryParams["height"] = [
                `${convertInchesToCentimeters(heightMin)}-${convertInchesToCentimeters(heightMax)}`, 
            ];
        }
    }
    // Format curated_status to map values like -1 that in slugify can't be in URL
    if (Boolean(filtersWithoutBasicQueryParams === null || filtersWithoutBasicQueryParams === void 0 ? void 0 : filtersWithoutBasicQueryParams["curated_status_value"])) {
        const curatedStatus = filtersWithoutBasicQueryParams["curated_status_value"].map((curatedValue)=>constants_2.CURATED_STATUS_MAPPING_VALUES[curatedValue]);
        filtersWithoutBasicQueryParams["curated_status"] = curatedStatus;
        delete filtersWithoutBasicQueryParams["curated_status_value"];
    }
    const facetsToSend = Object.fromEntries(Object.entries(filtersWithoutBasicQueryParams).filter(([key])=>allowedFacetNames.includes(key)));
    return facetsToSend;
};
exports.rulesToSendFilters = rulesToSendFilters;
const getAspectRatio = ({ isPrintsPage , aspectRatio =1 , printAspectRatio =1 ,  })=>{
    return isPrintsPage ? printAspectRatio : aspectRatio;
};
exports.getAspectRatio = getAspectRatio;
// Create a LIST of Shared Facets ** Slugifid Version **
// We use this to make sure we dont create a URL path of `/abstract/abstract`
// We will allow a second parameter for letting us know the order of importance
// We want to know what FacetName should take precedence
// facets: { styles: {'abstract': ...}, subject: {'abstract': ...}, }
// Result => { abstract: ['style', 'subject'] } OR { attibuteName: { facetName, facetName }}
const sharedFacetNameList = (dictionary, pathParams)=>{
    const pathKeys = pathParams || Object.keys(dictionary);
    const list = pathKeys.reduce((results, facetName)=>{
        const dictionaryValues = dictionary[facetName];
        if (dictionaryValues) {
            // Build out List of Items { abstract: [ 'styles', 'subject' ], paper: [ 'mediums' ], ...}
            Object.keys(dictionaryValues).forEach((attributeName)=>{
                if (results[attributeName]) {
                    // If Key VALUE exist, merge values together
                    results[attributeName] = [
                        ...results[attributeName],
                        facetName
                    ];
                } else {
                    results[attributeName] = [
                        facetName
                    ];
                }
            });
        }
        return results;
    }, {});
    // Filter List Down to items containing 2 Items
    return Object.entries(list).reduce((filteredList, [attibuteName, facetNames])=>Object.assign(Object.assign({}, filteredList), Array.isArray(facetNames) && facetNames.length !== 1 ? {
            [attibuteName]: facetNames
        } : null), {});
};
exports.sharedFacetNameList = sharedFacetNameList;
// Expects a object => { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... }
// Will return a new Object => { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... }
const buildSlugifyObject = (obj)=>Object.keys(obj).reduce((results, key)=>Object.assign(Object.assign({}, results), {
            [(0, slugify_1.slugify)(key)]: key === null || key === void 0 ? void 0 : key.toLowerCase()
        }), {});
const buildObject = (obj)=>Object.keys(obj).reduce((results, key)=>Object.assign(Object.assign({}, results), {
            [key]: key === null || key === void 0 ? void 0 : key.toLowerCase()
        }), {});
// Expects a object => { facets: { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... } }
// Will return a new Object => { facets: { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... } }
const buildConstructorSlugifyDictionary = (obj)=>Object.entries(obj).reduce((results, [key, value])=>key.search(/curated_status/) > -1 // Skip these values - do NOT slugify
         ? Object.assign(Object.assign({}, results), {
            [key]: buildObject(value)
        }) : Object.assign(Object.assign({}, results), {
            [key]: buildSlugifyObject(value)
        }), {});
exports.buildConstructorSlugifyDictionary = buildConstructorSlugifyDictionary;
// We use this FILE both SSR and Clientside, so NO FLOW
// We want to have a clean state/reset state
// (['style', 'category', ...]) => { style: [], category: [], ...}
const resetSelectedFacets = (facetNames)=>facetNames.reduce((results, facetName)=>Object.assign(Object.assign({}, results), {
            [facetName]: []
        }), {});
// We need to find out what `FacetName` a `AttributeName` belongs to
// Array#some -> escape as soon as TRUE || Return value
const getFacetName = ({ dictionary , name ,  })=>{
    let facetNameMatch = "";
    // Loop through all facets
    Object.entries(dictionary).some(([facetName, attributes])=>{
        // Loop through Attributes and look for a matching attributeName
        Object.keys(attributes).some((attributeName)=>{
            if (attributeName === name) {
                // Set the FacetName & Escape
                facetNameMatch = facetName;
                return facetNameMatch;
            }
        });
        if (facetNameMatch) {
            // Found the Match & Escape
            return facetNameMatch;
        }
    });
    return facetNameMatch;
};
/*
This function is meant to find all FacetValues and matching them back to FacetNames
Ex: '/painting/abstract' => { category: ['painting'], style: ['abstract']}
Uses position-based parsing: each URL segment corresponds to a facet by position in routeParams
`basePath` is an optional non-facet URL prefix (Ex: '/new-arrivals') that must be removed
before positional parsing so the remaining segments line up with routeParams.
*/ const getPathnameFacets = ({ dictionary , pathname , routeParams , booleanFacets ={} , basePath ="" ,  })=>{
    if (!dictionary || !pathname) {
        // Missing Data - Return empty Object
        return {};
    }
    let emptySelectedFacets = [];
    let dictionaryLookup;
    if (routeParams && Array.isArray(routeParams)) {
        // We KNOW what values to look for, and in what ORDER
        emptySelectedFacets = resetSelectedFacets(routeParams);
        // Custom Dictionary with ONLY routeParams
        dictionaryLookup = routeParams.reduce((data, facetName)=>{
            data[facetName] = dictionary[facetName] || {};
            return data;
        }, {});
    } else {
        // Create Empty Selected Values - All Values
        emptySelectedFacets = resetSelectedFacets(Object.keys(dictionary));
        // Use default Dictionary
        dictionaryLookup = dictionary;
    }
    // Remove Empty ITEMS Ex: '/some/url///thing' => ['', 'some', '', '', 'thing']
    const allSegments = pathname.split("/").filter(Boolean);
    // Strip the leading basePath segments (Ex: ['new-arrivals']) so the remaining
    // segments align positionally with routeParams. Only strip when the leading
    // segments actually match basePath, otherwise leave the pathname untouched.
    const baseSegments = (basePath || "").split("/").filter(Boolean);
    const hasBasePathPrefix = baseSegments.length > 0 && baseSegments.every((segment, index)=>allSegments[index] === segment);
    const list = hasBasePathPrefix ? allSegments.slice(baseSegments.length) : allSegments;
    // The position here is important since we have some values
    // that exist in multiple places (mediums and styles for example)
    const paramFacets = list.reduce((results, item, index)=>{
        if (routeParams && Array.isArray(routeParams)) {
            const positionFacetName = routeParams[index];
            if (!positionFacetName) {
                return results;
            }
            // has_prints facet
            if (positionFacetName === "has_prints" && item === "prints") {
                return Object.assign(Object.assign({}, results), {
                    has_prints: [
                        true
                    ]
                });
            }
            // boolean facets
            if (booleanFacets[positionFacetName] === item) {
                return Object.assign(Object.assign({}, results), {
                    [positionFacetName]: [
                        "true"
                    ]
                });
            }
            // Try position-based lookup first
            const positionFacetDict = dictionaryLookup[positionFacetName] || {};
            if (positionFacetDict[item] !== undefined) {
                return Object.assign(Object.assign({}, results), {
                    [positionFacetName]: [
                        item
                    ]
                });
            }
            // Position mismatch: check all boolean facets (they can appear at any URL position)
            for (const [key, value] of Object.entries(booleanFacets)){
                if (value === item && !results[key]) {
                    return Object.assign(Object.assign({}, results), {
                        [key]: [
                            "true"
                        ]
                    });
                }
            }
            // Last resort : search only page-scoped facets — dictionaryLookup excludes
            // materials on prints pages and print_materials on originals pages, so shared
            // slugs like canvas resolve to the correct facet without ambiguity
            const actualFacetName = getFacetName({
                dictionary: dictionaryLookup,
                name: item
            });
            if (actualFacetName && !results[actualFacetName]) {
                return Object.assign(Object.assign({}, results), {
                    [actualFacetName]: [
                        item
                    ]
                });
            }
            return results;
        }
        // Fallback for when routeParams is not available
        // Escape and Set Prints
        if (item === "prints") {
            return Object.assign(Object.assign({}, results), {
                has_prints: [
                    true
                ]
            });
        }
        for (const [key1, value1] of Object.entries(booleanFacets)){
            if (value1 === item) {
                return Object.assign(Object.assign({}, results), {
                    [key1]: [
                        "true"
                    ]
                });
            }
        }
        // Find Values => FacetName (first-match lookup - only used as fallback)
        const facetName = getFacetName({
            dictionary: dictionaryLookup,
            name: item
        });
        // Make sure it doesn't already exist, exit early/move to next param
        // Also don't create a entry if doesn't match a facetName
        if (!facetName || results[facetName]) {
            return results;
        }
        // Add to Results
        return Object.assign(Object.assign({}, results), {
            [facetName]: [
                item
            ]
        });
    }, {});
    return Object.assign(Object.assign({}, emptySelectedFacets), paramFacets);
};
// Ex: [ 'fine-art', 'fine-art', 'conceptual', 'impressionism', 'modern', 'conceptual']
// Results ['fine-art', 'conceptual', 'impressionism', 'modern',]
const restrictDuplicateValues = (facetValue)=>{
    if (Array.isArray(facetValue)) {
        return facetValue.reduce(// if Item Exist, Return Results, else Append Item to Results
        (results, item)=>results.includes(item) ? results : [
                ...results,
                item
            ], []);
    }
    // Single Object/String - Do Nothing
    return facetValue;
};
/*
We want to merge params and query together to create our Current Selected Facets
Params are ALWAYS types of Arrays and should also be EMPTY ARRAYS if not set
Ex: Params => { category: ['painting'], styles: [] }, Query => { styles: [abstract],  is_framed: 'true'}
Results => { category: ['painting'], styles: [abstract],  is_framed: 'true' }
*/ const mergeParamsQueryFacets = ({ params , query  })=>{
    if (!params || !query) {
        return {};
    }
    const selectedFacets = Object.assign({}, params);
    // merge parameters existing in two or more of the same query objects into an array
    Object.entries(query).forEach(([dirtyFacetName, facetValue])=>{
        // Lets also fix an issue with Parsing Queries and Remove Brackets
        // PROBLEM: We have to convert to create urls styles => ?styles[]=
        // Ex: query = { 'styles[]': ['abstract'] } => { styles: ['abstract'] }
        // CODE => `.replace(/\[\]/g, '')`
        const facetName = dirtyFacetName.replace(/\[\]/g, ""); // CLEAN Version
        // Value exists already
        if (selectedFacets[facetName]) {
            if (Array.isArray(facetValue)) {
                // If query value is already an array, concatenate array values
                selectedFacets[facetName] = [
                    ...selectedFacets[facetName],
                    ...facetValue
                ];
            } else {
                // Otherwise, make it an array, then concatenate values
                selectedFacets[facetName] = [
                    ...selectedFacets[facetName] || [],
                    facetValue
                ];
            }
        } else {
            // New value, add it
            selectedFacets[facetName] = Array.isArray(facetValue) ? facetValue : [
                facetValue
            ];
        }
    });
    // Sanity Check, No Duplicate FacetValues
    Object.entries(selectedFacets).forEach(([facetName, facetValue])=>selectedFacets[facetName] = restrictDuplicateValues(facetValue));
    return selectedFacets;
};
// Check Dictionary For Value OR return default (slugify) Value
// LOWER CASE NOW AS ALL VALUES ARE BEING LOWER CASE ON BACKEND FOR CONSTRUCTOR
const dictionaryLookup = ({ dictionary , facetName , facetValue  })=>{
    var _a;
    return dictionary[facetName] && ((_a = dictionary[facetName][facetValue]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (facetValue === null || facetValue === void 0 ? void 0 : facetValue.toLowerCase());
};
// Turn Slug back to Natural Values
const convertSlugifiedFacetsToNaturalValues = ({ dictionary , slugifiedFacets  })=>{
    const slugifiedResults = Object.assign({}, slugifiedFacets);
    Object.entries(slugifiedFacets).forEach(([facetName, facetValue])=>{
        // Does the FacetName exist in dictionary, unslugify values
        if (dictionary === null || dictionary === void 0 ? void 0 : dictionary[facetName]) {
            slugifiedResults[facetName] = Array.isArray(facetValue) ? facetValue.reduce((list, name)=>[
                    ...list,
                    dictionaryLookup({
                        dictionary,
                        facetName,
                        facetValue: name
                    }), 
                ], []) : dictionaryLookup({
                dictionary,
                facetName,
                facetValue
            });
        }
    });
    return slugifiedResults;
};
const parseUrlFacets = ({ dictionary , href , routeParams , booleanFacets ={} , basePath ="" ,  })=>{
    const { pathname , query  } = (0, url_1.parse)(href, true);
    // Query will already be PRETTY & Parsed, still need to parse pathname
    const paramsFacets = getPathnameFacets({
        dictionary,
        pathname,
        routeParams,
        booleanFacets,
        basePath
    });
    const mergedFacets = mergeParamsQueryFacets({
        params: paramsFacets,
        query
    });
    const naturalValues = convertSlugifiedFacetsToNaturalValues({
        dictionary,
        slugifiedFacets: mergedFacets
    });
    return naturalValues;
};
exports.parseUrlFacets = parseUrlFacets;
const getSortValues = ({ sort , destinationZone =""  })=>{
    const isSortByPrice = [
        facetNames_1.SORT_VALUES.PRICE_LOW_TO_HIGH,
        facetNames_1.SORT_VALUES.PRICE_HIGH_TO_LOW
    ].includes(sort);
    const sortObject = Object.assign({}, facetNames_1.SORT_BY_AND_ORDER[sort] || {
        sortBy: "",
        sortOrder: ""
    });
    // Needed to include destination zone in the sorting by price
    if (isSortByPrice) {
        sortObject.sortBy = `${facetNames_1.SORT_BY_AND_ORDER[sort].sortBy}-${destinationZone}`;
    }
    return sortObject;
};
exports.getSortValues = getSortValues;
function isSafeRedirectUrl(url) {
    try {
        const isJavascriptAttack = /javascript:/i.test(url);
        const isDataAttack = /data:/i.test(url);
        const isOnCallbackAttack = /\bon\w+=/g.test(url);
        const isScriptAttack = /<\s*script\s*>/gi.test(url);
        if (isJavascriptAttack || isDataAttack || isOnCallbackAttack || isScriptAttack) {
            return false;
        }
        // Encode parameters
        const sanitizedUrl = encodeURI(url);
        const parsedUrl = new URL(sanitizedUrl);
        // Ensure it uses HTTP or HTTPS
        if (![
            "http:",
            "https:"
        ].includes(parsedUrl.protocol)) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
}


/***/ }),

/***/ 7226:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (void 0) && (void 0).__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.ConstructorSearchService = void 0;
const transformConstructorFacetsToFilters_1 = __webpack_require__(92849);
const transformConstructorSearchResults_1 = __webpack_require__(62712);
const helpers_1 = __webpack_require__(44321);
const constructorGet_1 = __webpack_require__(79941);
const transformConstructorAutocompleteResults_1 = __webpack_require__(22612);
class ConstructorSearchService {
    constructor(params){
        this.userId = params.userId || "";
    }
    fetchSearchProviderData(_a) {
        return __awaiter(this, arguments, void 0, function*({ query ="" , filters ={} , predefinedFilters ={} , sort ="" , page =1 , resultsPerPage =100 , destinationZone ="US" , selectedCategory , isServerSide , isPrintsPage , userSizePreference , shouldAddGroupIdFilter , defaultSortObject , getContentRule , filterByIds , preFilterExpression ,  }) {
            var _b, _c, _d;
            try {
                // remove query, hitsPerPage and page from the filters sent
                const filtersWithoutBasicQueryParams = (0, helpers_1.rulesToSendFilters)({
                    filters,
                    destinationZone,
                    isPrintsPage,
                    userSizePreference,
                    shouldAddGroupIdFilter
                });
                const finalFiltersToSearchProvider = Object.assign(Object.assign({}, predefinedFilters), filtersWithoutBasicQueryParams);
                const { sortBy , sortOrder  } = (0, helpers_1.getSortValues)({
                    sort,
                    destinationZone
                });
                const response = yield (0, constructorGet_1.constructorGetData)({
                    query,
                    filters: finalFiltersToSearchProvider,
                    sortBy: Boolean(sortBy) ? sortBy : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortBy,
                    sortOrder: Boolean(sortOrder) ? sortOrder : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortOrder,
                    page,
                    resultsPerPage,
                    selectedCategory: isPrintsPage ? "prints" : selectedCategory,
                    isServerSide,
                    userId: this.userId,
                    filterByIds,
                    preFilterExpression
                });
                if (response.type === "redirect") {
                    return {
                        success: true,
                        payload: {
                            data: {
                                type: "redirect",
                                redirectLink: ((_c = (_b = response.redirect) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.url) || "",
                                matechedTerms: ((_d = response.redirect) === null || _d === void 0 ? void 0 : _d.matched_terms) || []
                            }
                        }
                    };
                }
                const transformedResults = (0, transformConstructorSearchResults_1.transformConstructorSearchResults)({
                    searchRequest: response.request,
                    searchResults: response.results,
                    destinationZone
                });
                const transformedContentRule = getContentRule ? (0, transformConstructorSearchResults_1.transformConstructorContentRule)({
                    constructorResponse: response.response
                }) : [];
                const mergedResults = (0, transformConstructorSearchResults_1.mergeContentRulesIntoResults)(transformedResults, transformedContentRule);
                const transformedFacets = (0, transformConstructorFacetsToFilters_1.transformConstructorFacetsToFilters)(response.facets);
                return {
                    success: true,
                    payload: {
                        data: {
                            type: "products",
                            results: mergedResults,
                            facets: transformedFacets,
                            totalResults: response.totalResults
                        }
                    }
                };
            } catch (error) {
                console.error("Error fetching search results from Constructor.io:", error);
                return {
                    success: false,
                    payload: {
                        message: "Error fetching search results from Constructor.io"
                    }
                };
            }
        });
    }
    fetchSearchProviderFacets(_a) {
        return __awaiter(this, arguments, void 0, function*({ query ="" , filters ={} , predefinedFilters ={} , sort ="" , page =1 , resultsPerPage =100 , destinationZone ="US" , selectedCategory , isServerSide , isPrintsPage , userSizePreference , shouldAddGroupIdFilter , defaultSortObject ,  }) {
            try {
                // remove query, hitsPerPage and page from the filters sent
                const filtersWithoutBasicQueryParams = (0, helpers_1.rulesToSendFilters)({
                    filters,
                    destinationZone,
                    isPrintsPage,
                    userSizePreference,
                    shouldAddGroupIdFilter
                });
                const finalFiltersToSearchProvider = Object.assign(Object.assign({}, predefinedFilters), filtersWithoutBasicQueryParams);
                const { sortBy , sortOrder  } = (0, helpers_1.getSortValues)({
                    sort,
                    destinationZone
                });
                const facetData = yield (0, constructorGet_1.constructorGetFacets)({
                    query,
                    filters: finalFiltersToSearchProvider,
                    sortBy: Boolean(sortBy) ? sortBy : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortBy,
                    sortOrder: Boolean(sortOrder) ? sortOrder : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortOrder,
                    page,
                    resultsPerPage,
                    selectedCategory: isPrintsPage ? "prints" : selectedCategory,
                    isServerSide,
                    userId: this.userId
                });
                const facetFromConstructor = Array.isArray(facetData) ? facetData : [];
                const transformedFacets = (0, transformConstructorFacetsToFilters_1.transformConstructorFacetsToFilters)(facetFromConstructor);
                return {
                    success: true,
                    payload: {
                        data: transformedFacets
                    }
                };
            } catch (error) {
                console.error("Error fetching facets from Constructor.io:", error);
                return {
                    success: false,
                    payload: {
                        message: "Error fetching facets from Constructor.io"
                    }
                };
            }
        });
    }
    fetchSearchProviderAutocomplete(_a) {
        return __awaiter(this, arguments, void 0, function*({ query ="" , filters ={} , numResults , shouldLowerCaseText , isServerSide ,  }) {
            var _b;
            try {
                const onlySpaces = ((_b = query === null || query === void 0 ? void 0 : query.trim()) === null || _b === void 0 ? void 0 : _b.length) === 0;
                if (onlySpaces) {
                    return {
                        success: true,
                        payload: {
                            data: {
                                matchedTerm: "",
                                autocompleteSuggestions: [],
                                totalResults: 0
                            }
                        }
                    };
                }
                const { request , sections , totalResultsPerSection  } = yield (0, constructorGet_1.constructorGetAutocomplete)({
                    query,
                    numResults,
                    filters,
                    isServerSide,
                    userId: this.userId
                });
                const autocompleteResults = (0, transformConstructorAutocompleteResults_1.transformConstructorAutocompleteResults)(sections, shouldLowerCaseText);
                return {
                    success: true,
                    payload: {
                        data: {
                            matchedTerm: (request === null || request === void 0 ? void 0 : request.term) || "",
                            autocompleteSuggestions: autocompleteResults,
                            totalResults: totalResultsPerSection.Products
                        }
                    }
                };
            } catch (error) {
                console.error("Error fetching autocomplete results from Constructor.io:", error);
                return {
                    success: false,
                    payload: {
                        message: "Error fetching autocomplete results from Constructor.io"
                    }
                };
            }
        });
    }
    fetchSearchProviderRecommendations(_a) {
        return __awaiter(this, arguments, void 0, function*({ podId ="" , filters ={} , numResults , section , isServerSide , itemIds ,  }) {
            try {
                const { response , totalResults , resultId  } = yield (0, constructorGet_1.constructorGetRecommendations)({
                    podId,
                    filters,
                    numResults,
                    section,
                    isServerSide,
                    userId: this.userId,
                    itemIds
                });
                return {
                    success: true,
                    payload: {
                        data: {
                            recommendations: ((response === null || response === void 0 ? void 0 : response.results) || []).map((result)=>Object.assign(Object.assign({}, result), (0, transformConstructorSearchResults_1.getConstructorSponsoredPlacement)(result))),
                            totalResults,
                            resultId
                        }
                    }
                };
            } catch (error) {
                console.error("Error fetching recommendations from Constructor.io:", error);
                return {
                    success: false,
                    payload: {
                        message: "Error fetching recommendations from Constructor.io"
                    }
                };
            }
        });
    }
}
exports.ConstructorSearchService = ConstructorSearchService;


/***/ }),

/***/ 22612:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.transformConstructorAutocompleteResults = void 0;
const client_1 = __webpack_require__(84694);
const transformConstructorAutocompleteResults = (sections, shouldLowerCaseText)=>{
    return ((sections === null || sections === void 0 ? void 0 : sections["Search Suggestions"]) || []).map(({ value  })=>{
        const text = shouldLowerCaseText ? value === null || value === void 0 ? void 0 : value.toLowerCase() : value;
        return {
            label: text,
            link: (0, client_1.addStoreLocaleByCookie)(`/all?query=${encodeURIComponent(text)}`)
        };
    });
};
exports.transformConstructorAutocompleteResults = transformConstructorAutocompleteResults;


/***/ }),

/***/ 92849:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.transformConstructorFacetsToFilters = void 0;
const transformConstructorFacetsToFilters = (facetsParams)=>{
    return facetsParams.reduce((acc, { name , options  })=>{
        acc[name] = (options || []).map(({ display_name , value , count  })=>({
                label: display_name,
                value: value,
                count: count
            }));
        return acc;
    }, {});
};
exports.transformConstructorFacetsToFilters = transformConstructorFacetsToFilters;


/***/ }),

/***/ 62712:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.mergeContentRulesIntoResults = exports.transformConstructorContentRule = exports.parseContentRuleIndexes = exports.transformConstructorSearchResults = exports.getConstructorSponsoredPlacement = void 0;
const helpers_1 = __webpack_require__(44321);
const helpers_2 = __webpack_require__(15722);
const getConstructorSponsoredPlacement = ({ labels , is_slotted ,  })=>({
        isSponsored: Boolean(labels === null || labels === void 0 ? void 0 : labels.is_retail_media),
        isSlotted: Boolean(is_slotted) && !Boolean(labels === null || labels === void 0 ? void 0 : labels.is_retail_media),
        slCampaignId: labels === null || labels === void 0 ? void 0 : labels.sl_campaign_id,
        slCampaignOwner: labels === null || labels === void 0 ? void 0 : labels.sl_campaign_owner
    });
exports.getConstructorSponsoredPlacement = getConstructorSponsoredPlacement;
const transformConstructorSearchResults = ({ searchRequest , searchResults , destinationZone ,  })=>{
    const { num_results_per_page: hitsPerPage = 100 , page =1  } = searchRequest || {};
    return searchResults.map(({ data , value , labels , is_slotted  }, index)=>{
        const { artist_first_name , artist_last_name , artist_id , artwork_category , country , depth , geo_prices , height , id , image_url , is_ready_to_hang , materials , mediums , orientation , styles , subject , url , width , artist_profile_url , image_aspect_ratio , print_image_aspect_ratio , print_min_price , print_materials , print_dimensions , print_frames , original_availability_status , print_availability_status , sku , created_at , curated_status ,  } = data;
        return Object.assign(Object.assign({
            // BaseArtwork fields
            artworkTitle: value,
            artworkId: id,
            artworkOriginalUrl: url,
            artworkSizeBin: "",
            artistFirstName: artist_first_name,
            artistLastName: artist_last_name,
            artistId: artist_id,
            artistProfileUrl: artist_profile_url,
            imageUrl: image_url,
            countryName: country,
            city: "",
            category: (0, helpers_2.capitalizeString)(artwork_category),
            aspectRatio: (0, helpers_1.getAspectRatio)({
                isPrintsPage: Boolean(print_min_price),
                aspectRatio: image_aspect_ratio,
                printAspectRatio: print_image_aspect_ratio
            }),
            dimensions: {
                widthInCentimeters: width,
                heightInCentimeters: height,
                depthInCentimeters: depth
            },
            hasPrintsAvailable: Boolean(print_min_price),
            geoPricesInCents: geo_prices,
            minPrintPriceInCents: print_min_price,
            originalArtworkStatus: original_availability_status,
            sku: sku !== null && sku !== void 0 ? sku : "--",
            styles,
            subject,
            materials,
            mediums,
            keywords: [],
            // PolaroidArtwork fields
            listPriceInCents: geo_prices === null || geo_prices === void 0 ? void 0 : geo_prices[destinationZone],
            artworkPrintUrl: url.replace("/art/", "/print/"),
            hasOpenEditions: Boolean(print_min_price),
            printAvailabilityStatus: print_availability_status,
            printMaterials: print_materials,
            printDimensions: print_dimensions,
            printFrames: print_frames,
            isReadyToHang: Boolean(is_ready_to_hang),
            orientation,
            positionID: hitsPerPage * (page - 1) + (index + 1),
            artworkUploadedDate: created_at,
            curatedStatus: curated_status
        }, (0, exports.getConstructorSponsoredPlacement)({
            labels,
            is_slotted
        })), {
            componentType: "artwork"
        });
    });
};
exports.transformConstructorSearchResults = transformConstructorSearchResults;
const parseContentRuleIndexes = (index)=>{
    if (!(index === null || index === void 0 ? void 0 : index.trim())) {
        return [];
    }
    return index.split(",").map((indexNumber)=>indexNumber.trim()).filter((indexNumber)=>indexNumber !== "");
};
exports.parseContentRuleIndexes = parseContentRuleIndexes;
const transformConstructorContentRule = ({ constructorResponse ,  })=>{
    const contentRules = (constructorResponse === null || constructorResponse === void 0 ? void 0 : constructorResponse.refined_content) || [];
    return contentRules.flatMap(({ data  })=>{
        const indexes = (0, exports.parseContentRuleIndexes)(data === null || data === void 0 ? void 0 : data.index);
        if (!indexes.length) {
            return [];
        }
        return indexes.map((index)=>({
                altText: (data === null || data === void 0 ? void 0 : data.altText) || "",
                assetUrl: (data === null || data === void 0 ? void 0 : data.assetUrl) || "",
                body: (data === null || data === void 0 ? void 0 : data.body) || "",
                ctaLink: (data === null || data === void 0 ? void 0 : data.ctaLink) || "",
                ctaText: (data === null || data === void 0 ? void 0 : data.ctaText) || "",
                header: (data === null || data === void 0 ? void 0 : data.header) || "",
                index,
                componentType: "custom"
            }));
    });
};
exports.transformConstructorContentRule = transformConstructorContentRule;
const mergeContentRulesIntoResults = (results, contentRules)=>{
    if (!contentRules.length) {
        return results;
    }
    const positionIDs = results.map((result)=>result.positionID);
    if (!positionIDs.length) {
        return results;
    }
    const minPositionID = Math.min(...positionIDs);
    const maxPositionID = Math.max(...positionIDs);
    const rulesInRange = contentRules.filter((rule)=>{
        const ruleIndex = Number(rule.index);
        return ruleIndex >= minPositionID && ruleIndex <= maxPositionID;
    });
    if (!rulesInRange.length) {
        return results;
    }
    const merged = [
        ...results
    ];
    const sortedRules = [
        ...rulesInRange
    ].sort((itemA, itemB)=>Number(itemA.index) - Number(itemB.index));
    sortedRules.forEach((rule)=>{
        // Compute array position relative to this page's starting positionID.
        // Splicing into the current (already-growing) array means each prior
        // insertion has already shifted subsequent slots, so consecutive rules
        // stack together naturally without an extra offset.
        const position = Math.min(Number(rule.index) - minPositionID + 1, merged.length);
        merged.splice(position, 0, rule);
    });
    return merged;
};
exports.mergeContentRulesIntoResults = mergeContentRulesIntoResults;


/***/ })

}]);